import { cn } from '@/lib/cn';

type Props = { className?: string };

export function PokeballSpinner({ className }: Props) {
  return (
    <svg
      role="status"
      aria-label="Loading"
      viewBox="0 0 24 24"
      className={cn('animate-spin motion-reduce:animate-none', className)}
    >
      <circle cx="12" cy="12" r="11" fill="white" stroke="black" strokeWidth="1.5" />
      <path d="M1 12 A11 11 0 0 0 23 12 Z" fill="#EE1515" stroke="black" strokeWidth="1.5" />
      <line x1="1" y1="12" x2="23" y2="12" stroke="black" strokeWidth="2.5" />
      <circle cx="12" cy="12" r="3.2" fill="white" stroke="black" strokeWidth="1.5" />
      <circle cx="12" cy="12" r="1.3" fill="white" stroke="black" strokeWidth="0.8" />
    </svg>
  );
}
